import * as React from 'react'

import { LoanOffer } from 'embed/constants/models'

import LoanOfferListItem from '../ListItem'

const styles = require('./styles.scss')

export interface Props {
  offer: LoanOffer
}

const SelectedOffer: React.SFC<Props> = ({ offer }) =>
  offer ? (
    <div className={styles.selectedOffer}>
      <p>
        <strong>Apply below to see if you qualify</strong>
      </p>
      <LoanOfferListItem offer={offer} hideCta={true} shouldDisplayTransunionDisclaimer={false} />
    </div>
  ) : null

export default SelectedOffer
